import {
  CHANGE_ACTIVE_WALLET_ID,
  FETCH_WALLET_TRANSACTIONS,
  FETCH_WALLETS,
  RESET_WALLET_TRANSACTIONS,
  RESET_WALLETS,
  SET_WALLET_NAME,
} from 'modules/Finance/Wallets/store/types'

export const actionGetWallets = () => ({ type: FETCH_WALLETS })
export const actionSetActiveWalletID = (props) => ({
  type: CHANGE_ACTIVE_WALLET_ID,
  payload: props,
})

export const actionGetWalletTransactions = (props) => ({
  type: FETCH_WALLET_TRANSACTIONS,
  payload: props,
})

export const actionResetWallets = () => ({ type: RESET_WALLETS })

export const actionResetTransactions = () => ({ type: RESET_WALLET_TRANSACTIONS })

export const actionSetWalletName = (props) => ({
  type: SET_WALLET_NAME,
  payload: props,
})
